import { observer } from 'mobx-react';

import { PayForm, PayMethods } from './components';
import { Store } from './stores';

const Component = () => {
  const store = Store.use();

  return !store.isPaymentTypeChosen ? <PayForm /> : <PayMethods />;
};

export const PageSend = observer(Component);
